module.exports = __webpack_public_path__ + "img/touKui1.bc43d5a7.png";